import * as React from "react"
import { createRoot } from "react-dom/client"
import "@/styles/globals.css"
import "@/styles/common.css"
import { UserProvider } from "@/context/UserContext"
import { IntegrationsPage } from "@/pages/integrations/IntegrationsPage"

/**
 * Public entry point for the Integrations catalog.
 * Mounted into Yii's `/integration` and `/integration/<id>` views.
 *
 * Differs from the shell entry:
 * - No sidebar / no shell chrome (Yii's main.php layout already wraps the page)
 * - Guest-friendly: window.__USER__ is unset for unauthenticated visitors;
 *   UserProvider yields user=null and components switch to guest mode.
 */
const container = document.getElementById("react-integrations-public")

if (container) {
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <UserProvider enableMock={false}>
        <div id="react-app" className="react-integrations-public mt-8 p-6">
          <IntegrationsPage rootPath="/integrations" />
        </div>
      </UserProvider>
    </React.StrictMode>,
  )
}
